class ControlError {
	constructor() {
		this.show = angular.isDefined(this.show) || true;
	}
}

export default ControlError;
